module.exports = __webpack_public_path__ + "static/media/QuiLe-cv.03afa8be.pdf";